export const THUMBNAIL_SIZE = 72;
export const THUMBNAIL_SIZE_XS = 56;

export const attachmentThumbnailStyles = {
	root: (clickable: boolean, isLarge: boolean) => ({
		position: 'relative',
		...(isLarge
			? {
					width: '100%',
					height: 100,
					'@media (hover: hover)': {
						'&:hover [data-slot="hover-overlay"]': {
							opacity: 1
						},
						'&:hover [data-slot="hover-remove-button"]': {
							pointerEvents: 'auto'
						}
					}
				}
			: {
					width: THUMBNAIL_SIZE,
					height: THUMBNAIL_SIZE,
					'@media (max-width: 600px)': {
						width: THUMBNAIL_SIZE_XS,
						height: THUMBNAIL_SIZE_XS
					}
				}),
		cursor: clickable ? 'pointer' : 'default',
		flexShrink: 0
	}),
	imageClip: {
		position: 'absolute',
		inset: 0,
		borderRadius: '4px',
		border: '1px solid',
		borderColor: 'divider',
		backgroundColor: 'background.paper',
		overflow: 'hidden'
	},
	image: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		display: 'block'
	},
	uploadingOverlay: {
		position: 'absolute',
		inset: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.6)'
	},
	errorOverlay: {
		position: 'absolute',
		inset: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(211, 47, 47, 0.85)',
		color: 'common.white'
	},
	removeButton: {
		position: 'absolute',
		top: -8,
		right: -8,
		width: 20,
		height: 20,
		padding: 0,
		backgroundColor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		'&:hover': {
			backgroundColor: 'background.paper'
		},
		'& .MuiSvgIcon-root': {
			fontSize: 14
		}
	},
	hoverOverlay: (touchEditVisible: boolean) => ({
		position: 'absolute',
		inset: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		p: 1,
		background:
			'linear-gradient(to top, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0) 55%)',
		opacity: touchEditVisible ? 1 : 0,
		transition: 'opacity 150ms ease',
		pointerEvents: 'none'
	}),
	hoverTopRow: {
		display: 'flex',
		justifyContent: 'flex-end'
	},
	hoverFileName: {
		color: 'common.white',
		fontSize: '0.75rem',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},
	hoverRemoveButton: (touchEditVisible: boolean) => ({
		flexShrink: 0,
		width: 24,
		height: 24,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		color: 'common.white',
		pointerEvents: touchEditVisible ? 'auto' : 'none',
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.7)'
		},
		'& .MuiSvgIcon-root': {
			fontSize: 16
		}
	})
};
